module.exports = __webpack_public_path__ + "img/slide-16.e65336d4.jpeg";